module.exports = __webpack_public_path__ + "static/media/shards-dashboards-logo.60a85991.svg";